module.exports = __webpack_public_path__ + "img/img-shop-food-2.d70887ee.png";